import React from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Row, Col, Divider, List, Spin, Dropdown, Button, Empty } from 'antd';
import { CloseCircleOutlined, DownCircleOutlined, EditOutlined, PrinterOutlined, InfoCircleOutlined, DownloadOutlined } from '@ant-design/icons';

import { _fmtRupiah, _warn } from '../../../../lib/Helper';

class Mobile extends React.Component {
  componentDidMount() {
    this.props.fetchTable(true)
  }

  render() {
    const { table } = this.props.state
    const action = this.props.access.action

    return (
      <>
        <Row gutter={[16, 16]}>
          <Col xs={24}>
            <InfiniteScroll
              dataLength={table.data.length}
              next={this.props.fetchTable}
              hasMore={table.pagination.total != null && table.data.length < table.pagination.total}
              loader={<div style={{ textAlign: "center" }}><Spin size="small" /></div>}
              endMessage={
                table.loading_first ? "" : (table.data.length ? <Divider /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Data tidak ditemukan" />)
              }
            >
              <List
                loading={table.loading_first}
                locale={{ emptyText: " " }}
                dataSource={table.data}
                renderItem={(row, i) => (
                  <List.Item
                    key={i}
                  >
                    <List.Item.Meta
                      title={row.pos_pengeluaran_nama}
                      description={<>
                        <Row gutter={[8, 8]}>
                          <Col xs={24}>
                            <small>
                              Tanggal Transaksi: {row.tgl_transaksi ? row.tgl_transaksi : "-"} <br />
                              Penanggung Jawab: {(row.tk_gelar_depan ? row.tk_gelar_depan : "") + (row.tk_nama ? row.tk_nama : "-") + (row.tk_gelar_belakang ? " " + row.tk_gelar_belakang : "")} <br />
                              Nominal: Rp. {_fmtRupiah(row.total_pengeluaran)} <br />
                              Bukti Kwitansi: {row.bukti_pembayaran ? <a rel="noopener noreferrer" target='_blank' href={row.main_path + row.bukti_pembayaran} style={{ fontSize: 11 }} >Download <DownloadOutlined /></a> : "-"} <br />
                              Keterangan: {row.keterangan ? row.keterangan : "-"} <br />
                            </small>
                          </Col>
                        </Row>
                      </>}

                    />
                    <div>
                      {(!action.invoice && !action.detail && !action.update && !action.update ? "-" : <Dropdown trigger={['click']} menu={{
  items: [...(action.invoice ? [{
    key: 0,
    icon: <PrinterOutlined />,
    label: "Invoice",
    onClick: () => {
      _warn("topRight", "Gagal", "Maaf, fitur ini belum tersedia");
    }
  }] : []), ...(action.detail ? [{
    key: 1,
    label: <Link to={`pengeluaran/detail/${row.id}`}><InfoCircleOutlined /> Detail</Link>
  }] : []), ...(action.update ? [{
    key: 2,
    icon: <EditOutlined />,
    label: "Update",
    onClick: this.props.modalForm.bind(this, true, row)
  }] : []), ...(action.delete ? [{
    key: 3,
    icon: <CloseCircleOutlined />,
    label: "Delete",
    onClick: this.props.modalDelete.bind(this, true, row)
  }] : [])]
}}>
                        <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                      </Dropdown>)}
                    </div>
                  </List.Item>
                )}
              />
            </InfiniteScroll>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Mobile);
